import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { EyeIcon } from '@heroicons/react/24/outline';

/**
 * Acceso al dataset de visión desde Configuración: cuántas muestras juntaron
 * los escáneres y cuántas esperan etiqueta.
 */
interface Stats { total: number; etiquetadas: number; sinEtiqueta: number }

export default function VisionDatasetSettings() {
  const navigate = useNavigate();
  const [stats, setStats] = useState<Record<string, Stats> | null>(null);

  useEffect(() => {
    axios.get('/api/vision/stats').then((r) => setStats(r.data || {})).catch(() => setStats({}));
  }, []);

  const pat = stats?.patente;
  const odo = stats?.odometro;
  const pendientes = (pat?.sinEtiqueta || 0) + (odo?.sinEtiqueta || 0);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <EyeIcon className="h-5 w-5" />
          Escáneres y dataset de visión
        </CardTitle>
        <CardDescription>
          Cada patente y odómetro que se escanea queda como muestra para reentrenar los modelos (Svetovid).
          Los intentos que el escáner no pudo leer esperan que alguien escriba lo que dice la foto.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap items-center justify-between gap-3">
        <div className="text-sm text-muted-foreground">
          {stats ? (
            <>
              Patentes: <span className="font-semibold text-foreground">{pat?.total || 0}</span> muestras ·
              Odómetros: <span className="font-semibold text-foreground">{odo?.total || 0}</span> muestras
              {pendientes > 0 && (
                <span className="ml-2 rounded-full bg-amber-500/15 px-2 py-0.5 text-xs font-bold text-amber-700 dark:text-amber-300">
                  {pendientes} sin etiquetar
                </span>
              )}
            </>
          ) : 'Cargando…'}
        </div>
        <Button variant="outline" size="sm" onClick={() => navigate('/vision-dataset')}>
          {pendientes > 0 ? `Etiquetar pendientes (${pendientes})` : 'Ver dataset'}
        </Button>
      </CardContent>
    </Card>
  );
}
